import {AbstractModel} from './abstract-model';
import {Product} from './product';
import {Currency} from './currency';
import {LandingPage} from './landing-page/landing-page';
import {Offer} from './offer';
import {Partner} from './partner/partner';
import {CustomPayout} from './custom-payout';

export class Conversion extends AbstractModel {
  id: number | null = null;
  createdAt: Date | null = null;
  cid: string | null = null;
  goalName: string | null = null;
  goalTypeName: string | null = null;
  conversionDate: Date | null = null;
  product: Product | null = null;
  amount: number | null = null;
  currencyAmount: number | null = null;
  currency: Currency | null = null;
  orderReference: string | null = null;
  paymentMethod: string | null = null;
  paymentPsp: string | null = null;
  paymentAcquirer: string | null = null;
  paymentThreeDSecure: boolean | null = null;
  paymentPartial: boolean | null = null;
  paymentPartialNumber: number | null = null;
  paymentRetry: boolean | null = null;
  paymentPspReference: string | null = null;
  paymentReference: string | null = null;
  paymentInitialReference: string | null = null;
  ip: string | null = null;
  userAgent: string | null = null;
  lastname: string | null = null;
  firstname: string | null = null;
  address: string | null = null;
  postalCode: string | null = null;
  city: string | null = null;
  country: string | null = null;
  language: string | null = null;
  email: string | null = null;
  subid: string | null = null;
  tc1: string | null = null;
  tc2: string | null = null;
  tc3: string | null = null;
  tc4: string | null = null;
  clickid: string | null = null;
  gclid: string | null = null;
  fbclid: string | null = null;
  fbpxid: string | null = null;
  msclkid: string | null = null;
  mspxid: string | null = null;
  twclid: string | null = null;
  twpxid: string | null = null;
  ttclid: string | null = null;
  ttpxid: string | null = null;
  source: string | null = null;
  payout: number | null = null;
  currencyPayout: number | null = null;
  payoutCurrency: Currency | null = null;
  payoutReason: string[] | null = null;
  referer: string | null = null;
  leadId: number | null = null;
  landingPage: LandingPage | null = null;
  offer: Offer | null = null;
  partner: Partner | null = null;
  uniqueReference: string | null = null;
  accepted: boolean = true;
  private: boolean = true;
  paid: boolean = true;
  underMinAgeForPayout: boolean | null = null;
  minAgeForPayout: number | null = null;
  customPayout: CustomPayout | null = null;
  multiple: boolean = false;

  override deserialize(input: any): this {
    super.deserialize(input);

    if (input.product) {
      this.product = new Product().deserialize(input.product);
    }

    if (input.currency) {
      this.currency = new Currency().deserialize(input.currency)
    }

    if (input.payoutCurrency) {
      this.payoutCurrency = new Currency().deserialize(input.payoutCurrency);
    }

    if (input.landingPage) {
      this.landingPage = new LandingPage().deserialize(input.landingPage);
    }

    if (input.offer) {
      this.offer = new Offer().deserialize(input.offer);
    }

    if (input.partner) {
      this.partner = new Partner().deserialize(input.partner);
    }

    if (input.customPayout) {
      this.customPayout = new CustomPayout().deserialize(input.customPayout);
    }

    return this;
  }

  getFullCustomerName(): string {
    let fullName: string = this.firstname ?? '';

    if (this.lastname) {
      fullName += ' ' + this.lastname;
    }

    return fullName;
  }
}
